<template>
  <div class="wrapper">
    <b-table :items="vendors" :fields="fields">
      <template v-slot:cell(name)="data">
        <div>
          {{ data.item.fullname || `${data.item.title} ${data.item.firstName} ${data.item.lastName}`}}
          <span v-if="data.item.knownAs"> ({{ data.item.knownAs }})</span>
          <br />
          {{ data.item.position }} -
          <span v-if="data.item.isDirector">Director, </span>
          <span v-if="data.item.isShareholder">Shareholder, </span>
          <span v-if="data.item.isAdvisor">Advisor, </span><br />
          <span v-if="data.item.shareholding"
            >Shareholding: {{ data.item.shareholding }}%
          </span>
        </div>
        <div v-if="data.item.isMainContact">
          <div><font-awesome-icon icon="check" /> Main Contact</div>
          <div v-if="data.item.correspondenceAddressLine1">
            {{ data.item.correspondenceAddressLine1 }}
          </div>
          <div v-if="data.item.correspondenceAddressLine2">
            {{ data.item.correspondenceAddressLine2 }}
          </div>
          <div v-if="data.item.correspondenceAddressLine3">
            {{ data.item.correspondenceAddressLine3 }}
          </div>
          <div v-if="data.item.correspondenceAddressLine4">
            {{ data.item.correspondenceAddressLine4 }}
          </div>
          <div v-if="data.item.correspondenceAddressLine5">
            {{ data.item.correspondenceAddressLine5 }}
          </div>
          <div v-if="data.item.correspondenceTown">
            {{ data.item.correspondenceTown }}
          </div>
          <div v-if="data.item.correspondenceCounty">
            {{ data.item.correspondenceCounty }}
          </div>
          <div v-if="data.item.correspondencePostcode">
            {{ data.item.correspondencePostcode }}
          </div>
        </div>

        <div v-if="!data.item.isMainContact">
          <b-button
            size="sm"
            variant="outline-secondary"
            type="button"
            @click="setMainContact(data.item.id)"
                    :disabled="readonly"
            ><font-awesome-icon icon="check" /> Set Main Contact</b-button>
        </div>
      </template>

      <template v-slot:cell(tel)="data">
        <div v-bind:class="{
            bold: data.item.companyVendorPreferredContactNumberId == 10,
            red: data.item.doNotUseTelephoneBusiness || data.item.telephoneBusinessCtps,
          }"
             v-if="data.item.telephoneBusiness">
          <font-awesome-icon icon="phone" /> {{ data.item.telephoneBusiness }}
          <b-button v-if="enableCallButtons && !data.item.doNotUseTelephoneBusiness"
                     variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(data.item.telephoneBusiness, data.item.id)">Call</b-button>
          <b-alert show variant="danger" v-if="data.item.telephoneBusinessCtps"> <small><small>CTPS ONLY USE IF PERMISSION IS GIVEN</small></small> </b-alert>
        </div>
        <div v-bind:class="{
            bold: data.item.companyVendorPreferredContactNumberId == 20,
            red: data.item.doNotUseTelephoneMobile || data.item.telephoneMobileCtps,
          }"
             v-if="data.item.telephoneMobile">
          <font-awesome-icon icon="phone" /> {{ data.item.telephoneMobile }}
          <b-button v-if="enableCallButtons && !data.item.doNotUseTelephoneMobile && data.item.hasMobileConsent"
                     variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(data.item.telephoneMobile, data.item.id)">Call</b-button>
          <b-button v-if="enableCallButtons && !data.item.doNotUseTelephoneMobile && !data.item.hasMobileConsent"
                    variant="info"
                    type="button"
                    size="sm"
                    disabled
                    title="Please gain consent to call this number">Call</b-button>
          <b-alert class="mt-1" show variant="info" v-if="enableCallButtons && !data.item.doNotUseTelephoneMobile && !data.item.hasMobileConsent"><small>Please gain consent to call this number</small></b-alert>          
          <b-alert show variant="danger" v-if="data.item.telephoneMobileCtps"> <small><small>CTPS ONLY USE IF PERMISSION IS GIVEN</small></small> </b-alert>
        </div>
        <div v-bind:class="{
            bold: data.item.companyVendorPreferredContactNumberId == 30,
            red: data.item.doNotUseTelephoneAlternative || data.item.telephoneAlternativeCtps,
          }"
             v-if="data.item.telephoneAlternative">
          <font-awesome-icon icon="phone" />
          {{ data.item.telephoneAlternative }}
          <b-button v-if="enableCallButtons && !data.item.doNotUseTelephoneAlternative"
                     variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(data.item.telephoneAlternative, data.item.id)">Call</b-button>
          <b-alert show variant="danger" v-if="data.item.telephoneAlternativeCtps"> <small><small>CTPS ONLY USE IF PERMISSION IS GIVEN</small></small> </b-alert>
        </div>
      </template>

      <template v-slot:cell(email)="data">
        <div
          v-bind:class="{ red: data.item.doNotUseEmailAddress }"
          v-if="data.item.emailAddress"
        >
          <font-awesome-icon icon="envelope" /> {{ data.item.emailAddress }}
        </div>
        <div
          v-bind:class="{ red: data.item.doNotUseEmailAddressAlternative }"
          v-if="data.item.emailAddressAlternative"
        >
          <font-awesome-icon icon="envelope" />
          {{ data.item.emailAddressAlternative }}
        </div>
        <div>

        </div>
      </template>

      <template v-slot:cell(nav)="data">
        <b-button block
            size="sm"
            variant="warning"
            type="button"
            @click="editVendor(data.item)"
                  :disabled="readonly"
            ><font-awesome-icon icon="edit" />&nbsp;Edit</b-button>
            <b-button block
            size="sm"
            variant="danger"
            type="button"
            @click="deleteContact(data.item.id)"
                      :disabled="readonly"
            ><font-awesome-icon icon="times" />&nbsp;Delete</b-button>

            <b-button
              v-if="(data.item.emailAddress && !data.item.doNotUseEmailAddress)
                || (data.item.emailAddressAlternative && !data.item.doNotUseEmailAddressAlternative)"
              block
              size="sm"
              variant="primary"
              type="button"
              @click="sendBrochure(data.item.id, 'email_no_contact')"
              :disabled="readonly"
            ><font-awesome-icon icon="envelope" />&nbsp;Brochure</b-button>

      </template>
    </b-table>

  </div>
</template>

<script>

import CompanyService from "@/services/Company.service";

export default {
  name: "ContactRow",
  components: {},
  props: {
    vendors: Array,
    lookups: Object,
    readonly: Boolean,
    enableCallButtons: Boolean,
    callInProgress: Boolean,
    callLocation: String
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name & Shareholding", sortable: false },
        { key: "tel", label: "Telephone", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "nav", label: "", sortable: false },
      ],
    };
  },
  methods: {
    editVendor(vendor) {
      this.$parent.editVendor(vendor);
    },
    setMainContact(id) {
      CompanyService.setMainContact(id).then(() => {
        this.$parent.$parent.$parent.$parent.loadData()
      })
    },
    deleteContact(id) {

      var service = CompanyService;
      this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this record?')
        .then(value => {
          if (value) {
            service.deleteCompanyVendor(id).then(() => {
              this.$parent.$parent.$parent.$parent.loadData()
            })
          }
        })
    },
    sendBrochure(id, type) {
      if (confirm("Send Brochure?")){
        CompanyService.sendBrochure(id, type).then(() => {
          alert("Email sent!");
        });
      }      
    },
    makeCall(number, vendorId) {
      this.$emit('makeCall', number, vendorId, this.callLocation);
    }
  }
};
</script>

<style scoped>

.dropdown-toggle-padded {
  margin-top: 0.5rem;
}

.wrapper {
  font-size: 0.85em;
}

.bold {
  font-weight: bold;
}
</style>
